module.exports = __webpack_public_path__ + "img/Donna Mina.ca2850c2.jpg";